import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inputFloatLabel: {
    description: 'editFilterViewModal.inputFloatLabel',
    defaultMessage: 'View Name',
    id: 'MY0VGm',
  },
  deleteView: {
    description: 'deleteFilterViewModal.deleteFilterView',
    defaultMessage: 'Delete this view',
    id: '+tdY9f',
  },
  noViewNameErrorMessage: {
    description: 'saveFilterViewModal.noNameErrorMessage',
    defaultMessage: 'No name entered for view.',
    id: 'Lumdrr',
  },
  existingViewNameErrorMessage: {
    description: 'saveFilterViewModal.errorMessage',
    defaultMessage: 'This name is already taken by an existing saved view.',
    id: 'sMyQYN',
  },
  deleteViewErrorHeader: {
    description: 'saveFilterViewModal.error',
    defaultMessage: 'Error',
    id: 'bbcy40',
  },
  editViewModalHeader: {
    description: 'editFilterViewModal.title',
    defaultMessage: 'Edit View',
    id: 'lMfpna',
  },
  deleteButtonText: {
    description: 'deleteFilterViewModal.deleteView',
    defaultMessage: 'Delete this view',
    id: 'Fp+VlC',
  },
  cancelButtonText: {
    description: 'saveFilterViewModal.cancel',
    defaultMessage: 'Cancel',
    id: 'z4GPwN',
  },
  saveButtonText: {
    description: 'saveFilterViewModal.saveView',
    defaultMessage: 'Save View',
    id: 'digyTp',
  },
});
